/*  ========================================================================
    # Scripts - Newsletter Modal
    ========================================================================  */

/**
 *
 */

const NewsletterModal = {
  cfg: {
    newsletterDialogElement: document.querySelector('.c-footer__newsletter-dialog'),
    newsletterButtonElement: document.querySelector('[data-newsletter-toggle]')
  },

  /**
   * Show/hide newsletter modal.
   */
  handleToggleClick() {
    this.cfg.newsletterButtonElement.addEventListener('click', () => {
      this.cfg.newsletterDialogElement.showModal();
      document.body.style.overflow = 'hidden';
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.newsletterButtonElement && this.cfg.newsletterDialogElement) {
      this.handleToggleClick();

      this.cfg.newsletterDialogElement.addEventListener('close', () => {
        document.body.style.overflow = 'auto';
      });
    }
  }
};

export default NewsletterModal;
